import { connect } from 'react-redux'
import requestPositionDocumentListItem from '../sagas/requestPositionDocumentListItem'
import requestAddDocumentToDocumentList from '../sagas/requestAddDocumentToDocumentList'
import requestUploadStart from '../sagas/requestUploadStart'
import documentListSelector from './documentListSelector'
import DocumentList from './DocumentList'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  documentListSelector,
  {
    requestPositionDocumentListItem,
    requestAddDocumentToDocumentList,
    requestUploadStart,
  },
  null,
  {
    forwardRef: true,
  }
)(DocumentList))
